// libs
import { styled } from '@nykaa/ui-components';

// mixin
import { truncate } from 'shared/styles/mixin';

export const Wrapper = styled.div<{ isSelected: boolean; }>`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing.spacing60} ${theme.spacing.spacing80}`};
  ${({ isSelected, theme }) =>
    !isSelected &&
    `&:hover {
    background-color: ${theme.colors.filterHover}
  }`};
  ${({ isSelected, theme }) => isSelected && `background-color: ${theme.colors.filterSelected}`};
  svg path {
    fill: ${({ theme }) => theme.colors.surface};
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  ${truncate}
`;

export const OptionName = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.bodyMedium};
  ${truncate}
`;

export const OptionCount = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  align-self: center;
  ${({ theme }) =>
    `color: ${theme.colors.textSecondary};
    margin: ${theme.spacing.spacing0} ${theme.spacing.spacing40};
    padding-top: ${theme.spacing.spacing10};
  `};
`;
